module.exports = __webpack_public_path__ + "img/zglt.92386242.png";